export default __webpack_public_path__ + "c215c3eadc8b6ff595dd556a40f34c7f.png";